import type { ModuleKey } from '@risksmart-app/modules/src/index';

/**
 * Control-test entity strings for the shared Smart Copy code — the single
 * per-entity source of truth a register supplies (keeps the shared code
 * entity-agnostic).
 *
 * - `moduleKey` — per-org feature toggle, typed against the module tree.
 * - `eventLabel` — prefixes the Amplitude event names (capitalised); 'Control
 *   Test' reproduces the deployed strings.
 * - `entityNoun` — interpolates into the disabled tooltip (lowercase); 'test
 *   result' reproduces the deployed wording.
 */
export const CONTROL_TEST_SMART_COPY = {
  moduleKey: 'control.subModules.control_test_smart_copy' satisfies ModuleKey,
  eventLabel: 'Control Test',
  entityNoun: 'test result',
} as const;
